export const leaderboardPrizes = {
	byRevenue: {
		gold: {
			prize: '2 000',
		},
		silver: {
			prize: '500',
		},
		bronze: {
			prize: '200',
		},
	},
	byAttendees: {
		gold: {
			prize: '2 000',
		},
		silver: {
			prize: '500',
		},
		bronze: {
			prize: '200',
		},
	},
};
